import get from "lodash.get";
import AbstractApiUtils from "services/cores/abstractApiUtils";

class IndicatorsUtils extends AbstractApiUtils {
  getFilters = (state) => {
    const filters = get(state.Indicators, "filters");

    return {
      ...(get(filters, "tag") && get(filters, "tag") !== "no-value"
        ? { tag: get(filters, "tag") }
        : {}),
      ...(get(filters, "group") && get(filters, "group") !== "no-value"
        ? { group: get(filters, "group") }
        : {}),
    };
  };

  formatListFromApi = (list) => {
    return {
      items: get(list, "data", []),
      others: {},
    };
  };

  INDICATORS_TYPES = {
    CARS: "CARS",
    PEDESTRIAN: "PEDESTRIAN",
    TRUCK: "TRUCK",
    DELIVERY: "DELIVERY",
    BUS: "BUS",
    TWO_WHEELER: "TWO_WHEELER",
    BATTERY: "BATTERY",
  };

  INDICATORS_COLUMNS = {
    CARS: "nb_cars",
    PEDESTRIAN: "nb_pedestrians",
    DELIVERY: "nb_delivery_vans",
    TRUCK: "nb_trucks",
    BUS: "nb_bus",
    TWO_WHEELER: "nb_two_wheelers",
    BATTERY: "nb_charging",
  };

  INDICATORS_COLORS = {
    MARKER: "#2A384B",
    MARKER_BORDER: "#c7c7c7",
    HOVER: "#2195A4",
  };
}

export default new IndicatorsUtils();
